"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateStress = void 0;
const calculationsCore_1 = require("../calculationsCore");
const types_1 = require("../types");
const calculateStress = (positions, tickers, calculationTimestamp, equity, indexPrice) => {
    const pnl = (0, calculationsCore_1.calculatePositionsPnl)([indexPrice * 0.5, indexPrice * 0.75, indexPrice * 1.25, indexPrice * 1.5], positions, tickers, types_1.CurrencyType.CRYPTO, types_1.ImpliedVolatilityType.STICKY_STRIKE, calculationTimestamp, true, 1);
    return pnl.todayLine.map((x) => x + equity);
};
exports.calculateStress = calculateStress;
